import { createContext, useContext, useState } from 'react';

const HostStreamContext = createContext();

const initialState = {
  tempCapturedImage: null,
  selectedView: 'control',
  recordDateTime: null,
  currentStep: 0,
  capturedImage: { first: null, second: null },
  notes: '',
};

const HostStreamProvider = ({ children }) => {
  const [state, setState] = useState(() => ({
    ...initialState,
  }));

  const updateState = (payload) => {
    setState((prev) => ({ ...prev, ...payload }));
  };
  const resetState = () => setState(initialState);

  return <HostStreamContext.Provider value={{ updateState, resetState, state }}>{children}</HostStreamContext.Provider>;
};

export const useHostStreamState = () => {
  return useContext(HostStreamContext);
};

export default HostStreamProvider;
